var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "langs"
  }, [_c('span', {
    staticClass: "lang",
    class: {
      'selected': _vm.lang === 'en', 'not-hovered': _vm.browser === 'ios'
    },
    on: {
      "click": function($event) {
        _vm.setLang('en')
      }
    }
  }, [_c('span', [_vm._v("En")])]), _vm._v(" "), _c('span', {
    staticClass: "lang",
    class: {
      'selected': _vm.lang === 'ru', 'not-hovered': _vm.browser === 'ios'
    },
    on: {
      "click": function($event) {
        _vm.setLang('ru')
      }
    }
  }, [_c('span', [_vm._v("Ru")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50de89ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Langs.vue
// module id = 193
// module chunks = 0